import { render } from "./IconStockroom.vue?vue&type=template&id=75cdafd4"
import script from "./IconStockroom.vue?vue&type=script&lang=ts"
export * from "./IconStockroom.vue?vue&type=script&lang=ts"
script.render = render

export default script